/**
 * Amber warning list for preview/result reports (merge + remove dialogs) —
 * the non-blocking "this also happens" notes of a `MergeReport`/`RemovalReport`.
 * Renders nothing when there is nothing to warn about.
 */
export interface WarningListProps {
  warnings: string[];
}

export function WarningList({ warnings }: WarningListProps) {
  if (warnings.length === 0) return null;
  return (
    <ul className="space-y-1">
      {warnings.map((warning) => (
        <li
          key={warning}
          className="rounded-md bg-amber-50 px-3 py-2 text-sm text-amber-800 dark:bg-amber-950/40 dark:text-amber-300"
        >
          {warning}
        </li>
      ))}
    </ul>
  );
}
